import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import SectionHeading from '@/components/feature/SectionHeading';

export default function ArticleSection() {
  const { t } = useTranslation();
  const list = articles.slice(0, 3);

  return (
    <section className="bg-background-100/60 py-12 md:py-16" aria-label={t('sec_article')}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <SectionHeading title={t('sec_article')} desc={t('sec_article_desc')} />
          <Link
            to={`/article/${articles[0].id}`}
            className="mb-1 hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700 sm:flex"
          >
            {t('sec_more')}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:border-primary-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.cover}
                  alt={article.title}
                  title={`${article.title} - 动漫网文章`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
                  {article.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-600">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {article.summary}
                </p>
                <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line" aria-hidden="true"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true"></i>
                    {article.date}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}